import AuthService from '../services/AuthService'

// Logout centrale condiviso tra DashboardPage e LogoutPage.
//
// Il cookie di sessione e' HttpOnly: a toglierlo e' la risposta di questa
// chiamata (delete_cookie lato backend), non il browser. Se la richiesta non
// arriva, la sessione resta viva davvero — quindi qui l'errore si vede, ma
// la pulizia locale si fa lo stesso, altrimenti l'utente resta agganciato
// all'auto-redirect verso la VM.
export const performCentralLogout = async () => {
  try {
    await AuthService.logout()
  } catch (e) {
    console.error('[Portal] logout non riuscito: la sessione puo\' essere ancora viva', e)
  }
  sessionStorage.clear()
}
